export default __webpack_public_path__ + "static/media/add-item.cc92ca65.svg";